function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.968 21c-5.799 0-10.5-4.701-10.5-10.5S5.169 0 10.968 0s10.5 4.701 10.5 10.5S16.767 21 10.968 21zm0-1.91a8.557 8.557 0 0 0 6.358-2.828 8.17 8.17 0 0 0-1.177-.985 11.91 11.91 0 0 0-1.827-.988 3.986 3.986 0 0 1-6.546.123c-.456.218-.951.483-1.427.803-.588.396-1.096.882-1.496 1.314a8.559 8.559 0 0 0 6.115 2.561zM13 12.062V10a2 2 0 0 0-4 0v2.062a2 2 0 1 0 4 0zM10.968 1.909A8.59 8.59 0 0 0 2.377 10.5c0 1.676.488 3.236 1.319 4.558.478-.528 1.153-1.194 1.917-1.708a9.39 9.39 0 0 1 1.437-.787c-.021-.166-.05-.329-.05-.501V10a4 4 0 1 1 8 0v2.062c0 .102-.023.198-.031.298.539.212 1.246.537 1.918.99.596.402 1.136.896 1.574 1.345a8.537 8.537 0 0 0 1.098-4.195 8.59 8.59 0 0 0-8.591-8.591z"
});

var SvgMenuClients = function SvgMenuClients(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuClients, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-clients.6c734dfb.svg";
export { ForwardRef as ReactComponent };